import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Landing, { AdminGate } from './pages/Landing';
import DataRecords from './pages/DataRecords';
import Editor from './pages/Editor';
import Runner from './pages/Runner';
import { checkHealth } from './lib/api';
import './styles/editor.css';
import './styles/cards.css';
import './styles/runner.css';
import './styles/features-0903.css';
import './styles/features-0907.css';
import './styles/runner-touch.css';

type Status = 'checking' | 'ok' | 'down';

export default function App() {
  const [status, setStatus] = useState<Status>('checking');

  useEffect(() => {
    let cancelled = false;
    checkHealth()
      .then(() => !cancelled && setStatus('ok'))
      .catch(() => !cancelled && setStatus('down'));
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing backendStatus={status} />} />
        <Route path="/records" element={<AdminGate><DataRecords onLogout={() => window.location.assign('/')} /></AdminGate>} />
        <Route path="/editor" element={<AdminGate><Editor mode="new" /></AdminGate>} />
        <Route path="/editor/:id" element={<AdminGate><Editor mode="edit" /></AdminGate>} />
        <Route path="/s/:id" element={<Runner />} />
        <Route path="/s/:id/done" element={<Runner mode="done" />} />
        <Route path="/edit/:token" element={<Runner mode="edit" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
